import Agilite from 'agilite'
import store from '../../../../../../store'
import { handleError } from '../../../../../lib/errorHandler'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

export const createMedicalImage = (data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        const userRef = store.getState().auth.agiliteUser._id
        const uploadedAt = new Date()

        response = await agilite.Connectors.execute('assessment_imaging', 'create', {
          data: JSON.stringify({
            ...data,
            userRef,
            uploadedBy: userRef,
            uploadedAt,
            createdAt: uploadedAt,
            createdBy: userRef,
            modifiedAt: uploadedAt,
            modifiedBy: userRef,
            isActive: true
          })
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const readMedicalImages = (filter) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        response = await agilite.Connectors.execute('assessment_imaging', 'read', {
          filter: JSON.stringify(filter)
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const updateMedicalImage = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        const userRef = store.getState().auth.agiliteUser._id
        const modifiedAt = new Date()

        response = await agilite.Connectors.execute('assessment_imaging', 'update', {
          recordId,
          data: JSON.stringify({
            ...data,
            modifiedAt,
            modifiedBy: userRef
          })
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const deleteMedicalImage = (recordId) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        const userRef = store.getState().auth.agiliteUser._id
        const modifiedAt = new Date()

        // Soft delete by setting isActive to false
        response = await agilite.Connectors.execute('assessment_imaging', 'update', {
          recordId,
          data: JSON.stringify({
            isActive: false,
            modifiedAt,
            modifiedBy: userRef
          })
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const getAssessmentImageById = (recordId) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        response = await agilite.Connectors.execute('assessment_imaging', 'find_by_id', {
          recordId
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}
